<template>
  <breadcrumb :links="{ '/': 'Home', 'current': 'Stazioni' }"></breadcrumb>

  <div class="container-xl p-0 py-sm-2 px-sm-3">
    <div class="search_container">
      <div class="row">
        <div class="col-md-4 stations_search_box">
          <div class="d-grid gap-2">
            <button class="btn btn-primary" id="search_stations_by_position"
              v-on:click="searchStationsByPosition">Stazioni più vicine</button>
          </div>
        </div>
        <div class="col-md-4 stations_search_box">
          <div class="d-flex flex-row justify-content-between">
            <select class="form-control flex-fill" id="search_stations_by_municipality"
              v-on:change="searchStationsByMunicipality">
              <option value="-1">Scegli un comune</option>
              <option v-for="m in municipalities" v-bind:key="m.id" :value="m.id">{{ m.name }}</option>
            </select>
            <button class="btn btn-primary" id="search_stations_by_municipality_button">Cerca</button>
          </div>
        </div>
        <div class="col-md-4 stations_search_box">
          <div class="d-flex flex-row justify-content-between">
            <input type="text" class="flex-fill form-control" id="station_name" v-model="station_name"
              placeholder="Nome stazione">
            <button class="btn btn-primary" id="search_stations_by_name" v-on:click="searchStationsByName">Cerca</button>
          </div>
        </div>
        <div class="col-12">
          <div v-if="alert" class="alert alert-warning alert-dismissible fade show" role="alert">
            <div>Nessuna stazione trovata con il criterio impostato</div>
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
          </div>
        </div>
      </div>

      <div class="list_container">
        <div v-if="main_loader" class="loader loading">
          <div class="lds-dual-ring"></div>
        </div>
        <div id="stations_list" class="d-none d-sm-block">
          <div v-if="measure_loader" class="loader loading">
            <div class="lds-dual-ring"></div>
          </div>
          <div v-if="stations.length == 0">
            <div class="container-xl">
              <p style="text-align: center">Scegli un criterio di ricerca per visualizzare le stazioni meteo oppure clicca
                sulla mappa.</p>
            </div>
          </div>
          <template v-else>
            <div class="search_results">
              <div v-for="station in stations" v-bind:key="station.id">
                <div class="container-xl station_overview">
                  <h3>
                    {{ station.name }}
                    <router-link :to="{ name: 'stazione', params: { id: station.id } }" class="btn btn-primary">Vai alla
                      stazione</router-link>
                  </h3>
                  <div class="sensor_note">Sensori principali</div>
                  <table class="table table-striped">
                    <tbody>
                      <template v-for="sensor in station.sensors">
                        <tr v-bind:key="sensor.id" v-if="sensor.measures && sensor.measures.length > 0">
                          <td class="measure_title">{{ sensor.name }}</td>
                          <td class="measure_value">{{ formatMeasure(sensor.measures[sensor.measures.length - 1].value,
                            sensor.decimals) }} <small>{{ sensor.unit }}</small></td>
                          <td class="measure_dt">{{ convertTime(sensor.measures[sensor.measures.length - 1].dt) }}</td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div id="map_container">
        <Map class="map" :center="center" :zoom="zoom" :markers="mapMarkers" >
          <template #popup="{ item }">
            <template v-if="item.get">
              <p class='text-primary fw-bold text-center'>{{ item.get('name') }}</p>
              <a :href="item.get('link')" class="btn btn-primary btn-sm">Vai al sensore</a>
            </template>
          </template>
        </Map>
      </div>
    </div>
  </div>

  <app-footer-mini></app-footer-mini>
</template>

<script>
import MonitorApi from '../services/MonitorApi';
import Labels from '@/utils/labels';
import AppFooterMini from '@/app-footer-mini.vue'
import Breadcrumb from '@/components/Breadcrumb'
import Map from '@/components/Map/BaseFvgMap'
import { v4 as uuidv4 } from 'uuid';
import { circleMarkerUI } from '@/components/Map/MapMarkers.js'

export default {
  name: "stations",
  mixins: [Labels],
  components: { AppFooterMini, Breadcrumb, Map },
  methods: {
    searchStationsByMunicipality: async function (event) {
      this.stations = []
      this.alert = false;
      this.main_loader = true;
      const istat = event.target.value;
      let stations = await MonitorApi.searchStations('istat', istat);
      this.showStationsOnMap(stations);
    },
    searchStationsByPosition: async function () {
      this.stations = []
      this.alert = false;
      this.main_loader = true;
      let me = this;
      navigator.geolocation.getCurrentPosition(async function (pos) {
        const position = [pos.coords.longitude, pos.coords.latitude].join(',');
        let stations = await MonitorApi.searchStations('position', position);
        me.showStationsOnMap(stations);
      });
    },
    searchStationsByName: async function () {
      this.stations = []
      this.alert = false;
      this.main_loader = true;
      let stations = await MonitorApi.searchStations('name', this.station_name);
      this.showStationsOnMap(stations);
    },
    async showStationsOnMap(stations) {
      let bounds = [[45.8, 12.9], [46.4, 13.3]];
      for (const i in stations) {
        const station = stations[i];
        if (i == 0) {
          bounds = [[station.lat - 0.1, station.lon - 0.1], [station.lat + 0.1, station.lon + 0.1]]
        }
        else {
          bounds = [[Math.min(bounds[0][0], station.lat), Math.min(bounds[0][1], station.lon)], [Math.max(bounds[1][0], station.lat), Math.max(bounds[1][1], station.lon)]]
        }
      }
      this.bounds = bounds;

      const ids = stations.map(station => station.id);
      for (const i in this.all_stations) {
		  const station = this.all_stations[i];
		  let active = ids.indexOf(station.id) == -1;
        this.mapMarkers.push({
          lat: station.lat,
          lon: station.lon,
          name: station.name,
          icon: `${uuidv4()}`,
          link: `#/stazione/${station.id}`,
        //   active: ,
		  ui: circleMarkerUI({ stroke: 'rgba(100,100,100,0.8)', fill: active ? 'rgba(200,200,200,0.5)' : 'rgba(0,250,0,0.7)' })
        });
      }

      this.main_loader = false;
      if (stations.length == 0) {
        this.alert = true;
      }
      else {
        this.measure_loader = true;
        this.stations = await MonitorApi.getMeasuresForStations(stations, this.top_sensors, [], 1);
        this.measure_loader = false;
      }
    }
  },
  data: function () {
    return {
      mapMarkers: [],
      center: [13.003024992385106, 46.08506324410948],
    //   from: 'Stations',
      zoom: 10,
      alert: false,
      main_loader: false,
      measure_loader: false,
      station_name: '',
      stations: [],
      all_stations: [],
      top_sensors: ['T', 'Tm', 'P', 'Vv', 'Dv', 'U', 'B', 'RG', 'N', 'Q_tot', 'IDRO_1', 'IDRO_2', 'IDRO_3', 'Q_1'],
      municipalities: [
        {
          "id": 30001,
          "name": "Aiello del Friuli"
        },
        {
          "id": 30002,
          "name": "Amaro"
        },
        {
          "id": 30003,
          "name": "Ampezzo"
        },
        {
          "id": 93001,
          "name": "Andreis"
        },
        {
          "id": 30004,
          "name": "Aquileia"
        },
        {
          "id": 93002,
          "name": "Arba"
        },
        {
          "id": 30005,
          "name": "Arta Terme"
        },
        {
          "id": 30006,
          "name": "Artegna"
        },
        {
          "id": 30007,
          "name": "Attimis"
        },
        {
          "id": 93004,
          "name": "Aviano"
        },
        {
          "id": 93005,
          "name": "Azzano Decimo"
        },
        {
          "id": 30008,
          "name": "Bagnaria Arsa"
        },
        {
          "id": 93006,
          "name": "Barcis"
        },
        {
          "id": 30009,
          "name": "Basiliano"
        },
        {
          "id": 30010,
          "name": "Bertiolo"
        },
        {
          "id": 30011,
          "name": "Bicinicco"
        },
        {
          "id": 30012,
          "name": "Bordano"
        },
        {
          "id": 93007,
          "name": "Brugnera"
        },
        {
          "id": 93008,
          "name": "Budoia"
        },
        {
          "id": 30013,
          "name": "Buja"
        },
        {
          "id": 30014,
          "name": "Buttrio"
        },
        {
          "id": 30015,
          "name": "Camino al Tagliamento"
        },
        {
          "id": 30016,
          "name": "Campoformido"
        },
        {
          "id": 30138,
          "name": "Campolongo Tapogliano"
        },
        {
          "id": 93009,
          "name": "Caneva"
        },
        {
          "id": 31001,
          "name": "Capriva del Friuli"
        },
        {
          "id": 30018,
          "name": "Carlino"
        },
        {
          "id": 93010,
          "name": "Casarsa della delizia"
        },
        {
          "id": 30019,
          "name": "Cassacco"
        },
        {
          "id": 93011,
          "name": "Castelnovo del Friuli"
        },
        {
          "id": 30020,
          "name": "Castions di Strada"
        },
        {
          "id": 93012,
          "name": "Cavasso Nuovo"
        },
        {
          "id": 30021,
          "name": "Cavazzo Carnico"
        },
        {
          "id": 30022,
          "name": "Cercivento"
        },
        {
          "id": 30023,
          "name": "Cervignano del Friuli"
        },
        {
          "id": 93013,
          "name": "Chions"
        },
        {
          "id": 30024,
          "name": "Chiopris Viscone"
        },
        {
          "id": 30025,
          "name": "Chiusaforte"
        },
        {
          "id": 93014,
          "name": "Cimolais"
        },
        {
          "id": 30026,
          "name": "Cividale del Friuli"
        },
        {
          "id": 93015,
          "name": "Claut"
        },
        {
          "id": 93016,
          "name": "Clauzetto"
        },
        {
          "id": 30027,
          "name": "Codroipo"
        },
        {
          "id": 30028,
          "name": "Colloredo di Monte Albano"
        },
        {
          "id": 30029,
          "name": "Comeglians"
        },
        {
          "id": 93017,
          "name": "Cordenons"
        },
        {
          "id": 93018,
          "name": "Cordovado"
        },
        {
          "id": 31002,
          "name": "Cormons"
        },
        {
          "id": 30030,
          "name": "Corno di Rosazzo"
        },
        {
          "id": 30031,
          "name": "Coseano"
        },
        {
          "id": 30032,
          "name": "Dignano"
        },
        {
          "id": 31003,
          "name": "Doberdò del Lago"
        },
        {
          "id": 30033,
          "name": "Dogna"
        },
        {
          "id": 31004,
          "name": "Dolegna del Collio"
        },
        {
          "id": 30034,
          "name": "Drenchia"
        },
        {
          "id": 32001,
          "name": "Duino Aurisina"
        },
        {
          "id": 30035,
          "name": "Enemonzo"
        },
        {
          "id": 93019,
          "name": "Erto e Casso"
        },
        {
          "id": 30036,
          "name": "Faedis"
        },
        {
          "id": 30037,
          "name": "Fagagna"
        },
        {
          "id": 93020,
          "name": "Fanna"
        },
        {
          "id": 31005,
          "name": "Farra d'Isonzo"
        },
        {
          "id": 93021,
          "name": "Fiume Veneto"
        },
        {
          "id": 30190,
          "name": "Fiumicello Villa Vicentina"
        },
        {
          "id": 30039,
          "name": "Flaibano"
        },
        {
          "id": 31006,
          "name": "Fogliano Redipuglia"
        },
        {
          "id": 93022,
          "name": "Fontanafredda"
        },
        {
          "id": 30137,
          "name": "Forgaria nel Friuli"
        },
        {
          "id": 30040,
          "name": "Forni Avoltri"
        },
        {
          "id": 30041,
          "name": "Forni di Sopra"
        },
        {
          "id": 30042,
          "name": "Forni di Sotto"
        },
        {
          "id": 93024,
          "name": "Frisanco"
        },
        {
          "id": 30043,
          "name": "Gemona del Friuli"
        },
        {
          "id": 30044,
          "name": "Gonars"
        },
        {
          "id": 31007,
          "name": "Gorizia"
        },
        {
          "id": 31008,
          "name": "Gradisca d'Isonzo"
        },
        {
          "id": 31009,
          "name": "Grado"
        },
        {
          "id": 30045,
          "name": "Grimacco"
        },
        {
          "id": 30046,
          "name": "Latisana"
        },
        {
          "id": 30047,
          "name": "Lauco"
        },
        {
          "id": 30048,
          "name": "Lestizza"
        },
        {
          "id": 30049,
          "name": "Lignano Sabbiadoro"
        },
        {
          "id": 30051,
          "name": "Lusevera"
        },
        {
          "id": 30052,
          "name": "Magnano in Riviera"
        },
        {
          "id": 30053,
          "name": "Majano"
        },
        {
          "id": 30054,
          "name": "Malborghetto Valbruna"
        },
        {
          "id": 93025,
          "name": "Maniago"
        },
        {
          "id": 30055,
          "name": "Manzano"
        },
        {
          "id": 30056,
          "name": "Marano Lagunare"
        },
        {
          "id": 31010,
          "name": "Mariano del Friuli"
        },
        {
          "id": 30057,
          "name": "Martignacco"
        },
        {
          "id": 31011,
          "name": "Medea"
        },
        {
          "id": 93026,
          "name": "Meduno"
        },
        {
          "id": 30058,
          "name": "Mereto di Tomba"
        },
        {
          "id": 30059,
          "name": "Moggio Udinese"
        },
        {
          "id": 30060,
          "name": "Moimacco"
        },
        {
          "id": 31012,
          "name": "Monfalcone"
        },
        {
          "id": 32002,
          "name": "Monrupino"
        },
        {
          "id": 30061,
          "name": "Montenars"
        },
        {
          "id": 93027,
          "name": "Montereale Valcellina"
        },
        {
          "id": 31013,
          "name": "Moraro"
        },
        {
          "id": 93028,
          "name": "Morsano al Tagliamento"
        },
        {
          "id": 30062,
          "name": "Mortegliano"
        },
        {
          "id": 30063,
          "name": "Moruzzo"
        },
        {
          "id": 31014,
          "name": "Mossa"
        },
        {
          "id": 32003,
          "name": "Muggia"
        },
        {
          "id": 30064,
          "name": "Muzzana del Turgnano"
        },
        {
          "id": 30065,
          "name": "Nimis"
        },
        {
          "id": 30066,
          "name": "Osoppo"
        },
        {
          "id": 30067,
          "name": "Ovaro"
        },
        {
          "id": 30068,
          "name": "Pagnacco"
        },
        {
          "id": 30069,
          "name": "Palazzolo dello Stella"
        },
        {
          "id": 30070,
          "name": "Palmanova"
        },
        {
          "id": 30071,
          "name": "Paluzza"
        },
        {
          "id": 30072,
          "name": "Pasian di Prato"
        },
        {
          "id": 93029,
          "name": "Pasiano di Pordenone"
        },
        {
          "id": 30073,
          "name": "Paularo"
        },
        {
          "id": 30074,
          "name": "Pavia di Udine"
        },
        {
          "id": 93030,
          "name": "Pinzano al Tagliamento"
        },
        {
          "id": 30075,
          "name": "Pocenia"
        },
        {
          "id": 93031,
          "name": "Polcenigo"
        },
        {
          "id": 30076,
          "name": "Pontebba"
        },
        {
          "id": 93032,
          "name": "Porcia"
        },
        {
          "id": 93033,
          "name": "Pordenone"
        },
        {
          "id": 30077,
          "name": "Porpetto"
        },
        {
          "id": 30078,
          "name": "Povoletto"
        },
        {
          "id": 30079,
          "name": "Pozzuolo del Friuli"
        },
        {
          "id": 30080,
          "name": "Pradamano"
        },
        {
          "id": 93034,
          "name": "Prata di Pordenone"
        },
        {
          "id": 30081,
          "name": "Prato Carnico"
        },
        {
          "id": 93035,
          "name": "Pravisdomini"
        },
        {
          "id": 30082,
          "name": "Precenicco"
        },
        {
          "id": 30083,
          "name": "Premariacco"
        },
        {
          "id": 30084,
          "name": "Preone"
        },
        {
          "id": 30085,
          "name": "Prepotto"
        },
        {
          "id": 30086,
          "name": "Pulfero"
        },
        {
          "id": 30087,
          "name": "Ragogna"
        },
        {
          "id": 30088,
          "name": "Ravascletto"
        },
        {
          "id": 30089,
          "name": "Raveo"
        },
        {
          "id": 30090,
          "name": "Reana del Rojale"
        },
        {
          "id": 30091,
          "name": "Remanzacco"
        },
        {
          "id": 30092,
          "name": "Resia"
        },
        {
          "id": 30093,
          "name": "Resiutta"
        },
        {
          "id": 30094,
          "name": "Rigolato"
        },
        {
          "id": 30095,
          "name": "Rive d'Arcano"
        },
        {
          "id": 30188,
          "name": "Rivignano Teor"
        },
        {
          "id": 31015,
          "name": "Romans d'Isonzo"
        },
        {
          "id": 31016,
          "name": "Ronchi dei Legionari"
        },
        {
          "id": 30097,
          "name": "Ronchis"
        },
        {
          "id": 93036,
          "name": "Roveredo in Piano"
        },
        {
          "id": 30098,
          "name": "Ruda"
        },
        {
          "id": 93037,
          "name": "Sacile"
        },
        {
          "id": 31017,
          "name": "Sagrado"
        },
        {
          "id": 31018,
          "name": "San Canzian d'Isonzo"
        },
        {
          "id": 30099,
          "name": "San Daniele del Friuli"
        },
        {
          "id": 32004,
          "name": "San Dorligo della Valle - Dolina"
        },
        {
          "id": 31019,
          "name": "San Floriano del Collio"
        },
        {
          "id": 93038,
          "name": "San Giorgio della Richinvelda"
        },
        {
          "id": 30100,
          "name": "San Giorgio di Nogaro"
        },
        {
          "id": 30101,
          "name": "San Giovanni al Natisone"
        },
        {
          "id": 30102,
          "name": "San Leonardo"
        },
        {
          "id": 31020,
          "name": "San Lorenzo Isontino"
        },
        {
          "id": 93039,
          "name": "San Martino al Tagliamento"
        },
        {
          "id": 31021,
          "name": "San Pier d'Isonzo"
        },
        {
          "id": 30103,
          "name": "San Pietro al Natisone"
        },
        {
          "id": 93040,
          "name": "San Quirino"
        },
        {
          "id": 30104,
          "name": "Santa Maria la Longa"
        },
        {
          "id": 93041,
          "name": "San Vito al Tagliamento"
        },
        {
          "id": 30105,
          "name": "San Vito al Torre"
        },
        {
          "id": 30106,
          "name": "San Vito di Fagagna"
        },
        {
          "id": 30189,
          "name": "Sappada"
        },
        {
          "id": 30107,
          "name": "Sauris"
        },
        {
          "id": 30108,
          "name": "Savogna"
        },
        {
          "id": 31022,
          "name": "Savogna d'Isonzo"
        },
        {
          "id": 30109,
          "name": "Sedegliano"
        },
        {
          "id": 93042,
          "name": "Sequals"
        },
        {
          "id": 93043,
          "name": "Sesto al Reghena"
        },
        {
          "id": 32005,
          "name": "Sgonico"
        },
        {
          "id": 30110,
          "name": "Socchieve"
        },
        {
          "id": 93044,
          "name": "Spilimbergo"
        },
        {
          "id": 31023,
          "name": "Staranzano"
        },
        {
          "id": 30111,
          "name": "Stregna"
        },
        {
          "id": 30112,
          "name": "Sutrio"
        },
        {
          "id": 30113,
          "name": "Taipana"
        },
        {
          "id": 30114,
          "name": "Talmassons"
        },
        {
          "id": 30116,
          "name": "Tarcento"
        },
        {
          "id": 30117,
          "name": "Tarvisio"
        },
        {
          "id": 30118,
          "name": "Tavagnacco"
        },
        {
          "id": 30120,
          "name": "Terzo d'Aquileia"
        },
        {
          "id": 30121,
          "name": "Tolmezzo"
        },
        {
          "id": 30122,
          "name": "Torreano"
        },
        {
          "id": 30123,
          "name": "Torviscosa"
        },
        {
          "id": 93045,
          "name": "Tramonti di Sopra"
        },
        {
          "id": 93046,
          "name": "Tramonti di Sotto"
        },
        {
          "id": 30124,
          "name": "Trasaghis"
        },
        {
          "id": 93047,
          "name": "Travesio"
        },
        {
          "id": 30126,
          "name": "Treppo Grande"
        },
        {
          "id": 30191,
          "name": "Treppo Ligosullo"
        },
        {
          "id": 30127,
          "name": "Tricesimo"
        },
        {
          "id": 32006,
          "name": "Trieste"
        },
        {
          "id": 30128,
          "name": "Trivignano Udinese"
        },
        {
          "id": 31024,
          "name": "Turriaco"
        },
        {
          "id": 30129,
          "name": "Udine"
        },
        {
          "id": 93052,
          "name": "Vajont"
        },
        {
          "id": 93053,
          "name": "Valvasone Arzene"
        },
        {
          "id": 30130,
          "name": "Varmo"
        },
        {
          "id": 30131,
          "name": "Venzone"
        },
        {
          "id": 30132,
          "name": "Verzegnis"
        },
        {
          "id": 30133,
          "name": "Villa Santina"
        },
        {
          "id": 31025,
          "name": "Villesse"
        },
        {
          "id": 30135,
          "name": "Visco"
        },
        {
          "id": 93049,
          "name": "Vito d'Asio"
        },
        {
          "id": 93050,
          "name": "Vivaro"
        },
        {
          "id": 93051,
          "name": "Zoppola"
        },
        {
          "id": 30136,
          "name": "Zuglio"
        }
      ]
    }
  },
  mounted: async function () {
    this.all_stations = await MonitorApi.getStations();
    this.showStationsOnMap([])
    this.alert = false;
  }
}

</script>
<style lang="scss" scoped>
.list_container {
  height: 50%;
  position: relative;
}

.section {
  margin-bottom: 20px;
  padding-top: 20px;
}

.search_container {
  display: flex;
  flex-direction: column-reverse;
  height: 100%;
  background-color: #f1f6f1;
}

#map_container {
  position: relative;
  height: 100%;

  .map {
    height: 100%;
  }
}

.loader {
  z-index: 2000;
  position: absolute;
  top: 0;
  bottom: 0;
  padding: 10px 0;
  width: 100%;
  opacity: 0.8;
}

.search_results {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  overflow: auto;

  .sensor_note {
    margin-top: -15px;
    font-style: italic;
    font-size: 0.8em;
    margin-left: 2px;
    color: #444;
  }
}

.station_sensor_badge {
  padding-right: 0px;
  margin-bottom: 30px;

  .measure_title,
  .measure_dt {
    font-variant: small-caps;
    text-align: center;
    display: block;
    color: #eee;
    background-color: #0067b1;
    font-weight: bold;
    font-size: 1.0em;
  }

  .measure_title {
    font-size: 1.2em;
  }

  .measure_value {
    text-align: center;
    color: #0067b1;
    background-color: #eee;
    font-weight: bold;
    padding: 5px 0;
    font-size: 63px;

    small {
      font-size: 25px;
    }
  }

  .measure_graph {
    padding-right: 0;
  }

  .measure_text {
    padding-left: 0;
  }
}

#stations_list {
  position: relative;
  width: 100%;
  height: 100%;
  float: left;
  z-index: 2000;

  p {
    font-size: 2em;
    color: #888;
    font-style: italic;
  }
}

.station_message {
  font-weight: bold;
  font-size: 1.2em;
  color: #666;
}

.stations_search_box {
  >div {
    padding: 10px;
  }
}

.station_overview {
  a {
    float: right;
  }

  table {
    background-color: white;
    width: 100%;
  }
}

.measures_list {
  a {
    float: right;
  }

  table {
    width: 100%;
  }
}

@media only screen and (max-width: 425px) {
  .list_container {
    height: 0;
    position: relative;
  }
}
</style>
